import React from 'react';

/**
 * @param {function} func - the function that you want to execute after the debounce time.
 * @param {number} wait - the amount of time you want the debounce function to wait.
 * @param {string} initialValue - the initial value for input.
 * @returns {Array} [string, function] returns Array of value and setValue;
 */
const useDebounceForInput = (func, wait = 150, initialValue = '') => {
  const [value, setValue] = React.useState(initialValue);
  const timeout = React.useRef();

  React.useEffect(() => {
    return () => clearTimeout(timeout.current);
  }, []);

  React.useEffect(() => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      func(value);
    }, wait);
  }, [value]);

  return [value, setValue];
};

export default useDebounceForInput;
export { useDebounceForInput };
